import axios from "axios";
import store from "../admin/store";
import { showNotification } from "../features/common/headerSlice";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "http://localhost:8080/",
  withCredentials: true, // to send cookies
});

api.interceptors.response.use(
  (response) => response,

  (error) => {
    const { response } = error;

    if (response && (response.status === 401 || response.status === 403)) {
      // Clean up authentication data
      api.post("/api/admin/logout").catch(() => {
        // Ignore logout errors
      });
      localStorage.removeItem("adminData");

      // Show notification to user about authentication error
      store.dispatch(
        showNotification({
          message: "Your session has expired. Please log in again to continue.",
          status: 0,
        }),
      );

      // Redirect to login after a short delay so user can see the message
      setTimeout(() => {
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }, 1500);
    }

    // Pass the error along to the calling function
    return Promise.reject(error);
  },
);

export default api;
